import React from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import { Link } from "react-router-dom";
import select_email_template_image from "../../assets/images/select_email_template_image.png";

const EmailTemplateModal = ({ setSelect }) => {
  return (
    <>
      <div className={`modal-wrapper overflow-y-auto h-full}`}>
        <div className={`side-modal w-[50%] h-screen}`}>
          <div className="flex mt-10 mb-8 justify-center">
            <div className="flex w-[80%] justify-between">
              <p className="text-[#2F80ED]">Email Template</p>
              <div onClick={() => setSelect(false)} className="cursor-pointer">
                <img src={cross_icon} alt="cross icon" />
              </div>
            </div>
          </div>

          <div className="flex justify-center mb-10">
            <img
              src={select_email_template_image}
              alt="selected image"
              className="shadow-2xl"
            />
          </div>
          <div className="flex justify-center text-[18px] mt-4 mb-16">
            <Link
              to="/profile/create-email"
              className="bg-[#2F80ED] text-white  p-4 rounded-lg flex justify-center cursor-pointer"
            >
              <button>Select this Template</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailTemplateModal;
